module.exports = __webpack_public_path__ + "static/media/feature_faust.013df76d.jpg";